import { render, staticRenderFns } from "./TestimonialsSingle.vue?vue&type=template&id=61344714"
import script from "./TestimonialsSingle.vue?vue&type=script&lang=js"
export * from "./TestimonialsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports